(function () {
  "use strict";

  var americanCC = [
    'US',
    'CA',
    'MX',
    'AR',
    'BO',
    'BR',
    'CL',
    'CO',
    'EC',
    'FK',
    'GF',
    'GY',
    'PY',
    'PE',
    'SR',
    'UY',
    'VE'
  ];

  var eurozoneCC = [
    'AT',
    'BE',
    'CY',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PT',
    'SK',
    'SI',
    'ES',
    'BG',
    'HR',
    'CZ',
    'HU',
    'PL',
    'RO',
    'SE',
  ];

  function convertCurrency(newCC) {
    $('.currency-picker').val(newCC).change();
  }

  function setCurrency(cc) {
    if (Currency.cookie.read() !== null) return;
    if (eurozoneCC.indexOf(cc) > -1) {
      convertCurrency('EUR');
      return;
    }

    switch(cc) {
    case 'IN':
      convertCurrency('INR');
      break;
    case 'CA':
      convertCurrency('CAD');
      break;
    case 'GB':
      convertCurrency('GBP');
      break;
    case 'JP':
      convertCurrency('JPY');
      break;
    case 'AU':
      convertCurrency('AUD');
      break;
    default:
      convertCurrency('USD');
    }
  }

  function setPhoneNumber(cc) {
    if (americanCC.indexOf(cc) > -1) {
      $('.phone-number').text('+1 888 4246295');
    }
  }
    
  $(document).ready(function() {
    
    $(".phone-wrapper").hover(
      function() {
        $(".phone-number-hidden").show();
      }, function() {
        $(".phone-number-hidden").hide();
      }
    );
    
    $(".talk_us").click(function() {
        $.fancybox.open({
    src: 'https://app.telbee.io/channel/lmkfwst26of1wdfg2hilsa',
            type: 'iframe',
    		preload: false,
            touch: false,
    		scrolling: 'no',
    		iframe: {
    			tpl:
      				'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allow="microphone;fullscreen" src=""></iframe>',
    			preload: false,
    			scrolling: 'no',
    			css : {
                    'min-width': '305px',
                    'max-width': '500px',
                    'width': '100%',
                    'max-height': '100%'   				
                }
    		}
        });
    });
    
  });

  function toggleDropdown($title, $body) {
    $title.click(function() {
      var bodyWasUp = $body.is(':hidden');
      var $arrow = $title.children('.arrow');

      $('.dropdown').each(function () {
        $(this).children('.body').slideUp();
        $(this).find('.arrow').css('transform', 'rotate(-90deg)');
      });

      if (bodyWasUp) {
        $body.slideDown();
        $arrow.css('transform', 'none');
      }
    });
  }

  function enableColorPicker() {
    var $colorOptions = $('.color-selector .color');
    var $colorName = $('#color-name');
    var $currentlySelected = $('.color.selected');
    var $skuName = $('#sku-name');
    var $btn_usa = $('.btn-amz-usa');
    var $btn_uk = $('.btn-amz-uk');
    var $usa_link = "https://www.amazon.com/s?merchant=A3BPY54OD5IOLM";
    var $uk_link = "https://www.amazon.co.uk/s?merchant=A2KIDLGQ73C8J5";
    
    var replacePics = function(url, oldVariant, newVariant) {
        var re = new RegExp(oldVariant, 'g');

        return url.replace(re, newVariant);
    };

    var getVariantName = function(variant) {
      return variant.split(' ').map(function(s) {
          return s.charAt(0).toUpperCase() + s.slice(1);
        }).join('');
    };

    $colorOptions.each(function() {
      var option = $(this).data('value');
      var sku = $(this).data('sku');
      var barcode = $(this).data('bc');

      $(this).mouseover(function() {
        $colorName.text(option);
    	$skuName.text(sku);

        $(this).addClass("selected");
      });

      $(this).mouseleave(function() {
        $colorName.text($currentlySelected.data('value'));
    	$skuName.text($currentlySelected.data('sku'));

        if (!($(this).is($currentlySelected))) {
          $(this).removeClass("selected");
        }
      });

      $(this).click(function() {
    
    	if (barcode == "") {
    		$btn_usa.attr("href", $usa_link);
    		$btn_uk.attr("href", $uk_link);
    	}
    	else {
    		$btn_usa.attr("href", "http://www.amazon.com/dp/"+barcode);
    		$btn_uk.attr("href", "http://www.amazon.co.uk/dp/"+barcode);
    	}
    
        $colorOptions.removeClass('selected');
        $('#productSelect-option-0').children('option[value="'+option+'"]')
          .prop('selected', 'selected').parent().trigger('change');
        $(this).addClass('selected');

        var oldVariant = getVariantName($currentlySelected.data('value'));
        var newVariant = getVariantName($(this).data('value'));

        $('.product-single__thumbnail').each(function() {
          var picUrl = $(this).attr('href');
          var $thumbnail = $(this).children('img').first();
          var thumbnailPicUrl = $thumbnail.attr('src');

          var replaceVariant = function(url) {
            return replacePics(url, oldVariant, newVariant);
          };

          $(this).attr('href', replaceVariant(picUrl));
          $thumbnail.attr('src', replaceVariant(thumbnailPicUrl));
        });

        $currentlySelected = $(this);
      });
    });
  }

  function enableSectionsDropdown() {
    $('.dropdown').each(function() {
      var $title = $(this).children('.title');
      var $body = $(this).children('.body');
      toggleDropdown($title, $body);
    });
  };

  function enableModelSelector() {
    $('#model-selector').on('change', function() {
      var url = $(this).val();
      window.location.replace(url);
    });
  }

  function initializeProductGallery() {
    var $gallery = $('#product-gallery');
    var $galleryNav = $('#gallery-nav');

    // Enable jQuery slick carousel.
    $gallery.slick({
      slideToShow: 1,
      slideToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '#gallery-nav',
    });

    $galleryNav.slick({
      slideToShow: 3,
      slideToScroll: 1,
      asNavFor: '#product-gallery',
      centerMode: true,
      focusOnSelect: true,
    });

    // jQuery zoom cannot be applied directly to img elements, so we are
    // applying it to the slick-slide image wrapper.
    // $gallery.find('.slick-slide').each(function() {
    //  var imgUrl = $(this).children('img').attr('src');
    //  $(this).zoom({ url: imgUrl, on: 'click' });
    // });
  }

  function initializeReviewsCarousel() {
    $('#reviews-carousel').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      ],
    });
  }

  function geoLocate() {
    var geoLocationServiceURL = "http://freegeoip.net/json/";

    $.getJSON(geoLocationServiceURL, function (location) {
      $(document).trigger('geolocated', location.country_code);
    });
  }

  jQuery(function($) {
    setCurrency('US');
    geoLocate();
    $(document).on('geolocated', function(e, cc) {
      setPhoneNumber(cc);
    });

    enableSectionsDropdown();
    enableColorPicker();
    enableModelSelector();
    initializeProductGallery();
    initializeReviewsCarousel();
  });
})();